import { ExperimentService } from '@/services/experiment.service';

export default {
  namespaced: true, 
  actions: {
    async getExperimentData() {
      try {
        const { data } = await ExperimentService.getExperimentData();
        return data;
      } catch (error) {
        console.error(error);
        return error;
      }
    }
  }
}